const env = process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV

export const DASHBOARD_API_URL: string =
  env === 'production'
    ? 'https://dashboard-api-dot-kompassdemo.appspot.com/v0'
    : 'https://dashboard-api-dot-opinary-dev.appspot.com/v0'

export const API_LOGIN_URL: string = `/login`
export const API_POLLS_SLIDER: string = `polls/sliders`
